import { render, staticRenderFns } from "./childCases.vue?vue&type=template&id=1dda9016&lang=pug"
import script from "./childCases.vue?vue&type=script&lang=js"
export * from "./childCases.vue?vue&type=script&lang=js"
import style0 from "./childCases.vue?vue&type=style&index=0&id=1dda9016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports